import { useState } from "react";
import { useLocale } from "../i18n/useLocale";

export function QuickSubprojectInput({ onAdd, className = "" }) {
  const { display } = useLocale();
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const submit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError(display.t("web.subproject.nameRequired"));
      return;
    }

    onAdd(trimmed);
    setName("");
    setError("");
  };

  return (
    <section
      className={`quick-subproject-input${className ? ` ${className}` : ""}`}
      aria-label={display.t("web.subproject.addRegion")}
    >
      <div>
        <p className="card-kicker">{display.t("web.subproject.kicker")}</p>
        <h2 className="quick-subproject-title">{display.t("web.subproject.addTitle")}</h2>
      </div>
      <p className="quick-subproject-hint">
        {display.t("web.subproject.hint")}
      </p>
      <div className="quick-subproject-row">
        <input
          className="quick-subproject-field"
          type="text"
          value={name}
          placeholder={display.t("web.subproject.placeholder")}
          onChange={(event) => {
            setName(event.target.value);
            if (error) setError("");
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              submit();
            }
          }}
          aria-invalid={Boolean(error)}
          aria-describedby={error ? "quick-subproject-feedback" : undefined}
        />
        <button type="button" className="primary-button" onClick={submit}>
          {display.t("web.subproject.addButton")}
        </button>
      </div>
      {error && (
        <div className="quick-subproject-feedback" id="quick-subproject-feedback" role="status">
          <span className="quick-subproject-error">{error}</span>
        </div>
      )}
    </section>
  );
}
